import React from 'react';
import SelectTalent from 'cms/components/SelectTalent';
import SelectLanguage from 'cms/components/SelectLanguage';
import 'cms/components/UsersFilterWidget.css';
import './PostsFilterWidget.css';

/**
 * CMS Posts list filters (GET → /cms/posts). Same shell styles as users filter widget.
 */
export default function PostsFilterWidget({ visible, filter_title, filter_talent, filter_language, onValue, onChange }) {
    if (!visible) {
        return null;
    }

    return (
        <div className="users-filter-widget users-filter-widget--posts">
            <form action="/cms/posts" method="get" className="users-filter-widget__form">
                <div className="users-filter-widget__body">
                    <div className="users-filter-widget__row users-filter-widget__row--posts">
                        <div className="users-filter-widget__cell users-filter-widget__cell--posts-title">
                            <input
                                type="text"
                                name="title"
                                className="form-control"
                                placeholder="Title"
                                value={filter_title || ''}
                                onChange={onChange}
                            />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--posts-talent">
                            <SelectTalent
                                value={filter_talent}
                                callback={onValue}
                                border="1"
                                width="100%"
                                usersFilter
                                placeholder="Talent"
                            />
                            <input type="hidden" name="category" value={filter_talent || ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--posts-language">
                            <SelectLanguage
                                value={filter_language}
                                callback={onValue}
                                width="100%"
                                placeholder="Language"
                            />
                            <input type="hidden" name="language" value={filter_language || ''} />
                        </div>
                        <div className="users-filter-widget__cell users-filter-widget__cell--actions">
                            <div className="users-filter-widget__actions">
                                <a href="/cms/posts" className="btn btn-cm users-filter-widget__btn">
                                    Clear
                                </a>
                                <button type="submit" className="btn btn-cm users-filter-widget__btn">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
